var ContainerColor;
(function (ContainerColor) {
    ContainerColor["TRANSPARENT"] = "transparent";
    ContainerColor["THEME_AWARE"] = "theme-aware";
    ContainerColor["NEUTRAL_GRADIENT_TOP_LEFT"] = "neutral-gradient-top-left";
    ContainerColor["NEUTRAL_GRADIENT_BOTTOM_RIGHT"] = "neutral-gradient-bottom-right";
    ContainerColor["NEUTRAL_GRADIENT_NEUTRAL_100_NEUTRAL_400"] = "neutral-gradient-neutral-100-neutral-400";
    ContainerColor["NEUTRAL_100"] = "neutral-100";
    ContainerColor["NEUTRAL_200"] = "neutral-200";
    ContainerColor["GREY_50"] = "grey-50";
    ContainerColor["GREY_100"] = "grey-100";
    ContainerColor["GREY_300"] = "grey-300";
    ContainerColor["WHITE"] = "white";
    ContainerColor["AWARE_SOFT_TOP_LEFT"] = "aware-gradient-top-left";
    ContainerColor["AWARE_SOFT_BOTTOM_RIGHT"] = "aware-gradient-bottom-right";
    ContainerColor["BLUE_GRADIENT_TOP_LEFT"] = "blue-gradient-top-left";
    ContainerColor["BLUE_GRADIENT_BOTTOM_RIGHT"] = "blue-gradient-bottom-right";
    ContainerColor["SPLIT_GRADIENT"] = "split-gradient-radial";
    ContainerColor["GRADIENT_WHITE_TO_GRAY_4"] = "split-gradient-linear";
    ContainerColor["BRAND_GRADIENT"] = "brand-gradient";
})(ContainerColor || (ContainerColor = {}));

export { ContainerColor as C };

//# sourceMappingURL=roche-container.types.js.map